<!-- Modals -->

<!-- Delete modal -->
<ui-dialog
    size="small"
    [open]="isDeleteModalOpen"
    header="{{ 'settings.custom-fields.deleteFieldname' | translate: { name: field.name } }}"
    [primaryButtonLabel]="'delete' | translate"
    (primaryButtonPressed)="onDelete()"
    [primaryButtonType]="'danger'"
    [secondaryButtonLabel]="'cancel' | translate"
    (secondaryButtonPressed)="isDeleteModalOpen = false"
    (closing)="isDeleteModalOpen = false"
>
    <div *ngIf="field?.assignedEmployeesCount > 0; else noAssignments">
        <p>
            {{
                'settings.custom-fields.removeFromProfileNotice'
                    | translate: { assignedEmployeeCount: field?.assignedEmployeesCount }
            }}
        </p>
        <p>{{ 'settings.custom-fields.saveDataBeforeDeleteNotice' | translate }}</p>
    </div>
    <ng-template #noAssignments> {{ 'settings.custom-fields.noAssignment' | translate }} </ng-template>
</ui-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="field?.name"
        [back]="true"
        backRoute="/settings/custom-fields/fields"
        contextMenuType="material"
        [contextMenu]="auth.isAdmin()"
    >
        <button mat-menu-item (click)="isDeleteModalOpen = true">{{ 'delete' | translate }}</button>
        <div class="buttons">
            <ui-button (click)="onAddOrRemoveEmployees()" type="primary" *permission="'administrate'">{{
                'settings.custom-fields.addRemoveEmployees' | translate
            }}</ui-button>
        </div>
    </app-header>

    <!-- Field Details -->
    <div class="ui segment">
        <app-segment-header
            title="{{ 'settings.custom-fields.fieldInformation' | translate }}"
            (edit)="onEditFieldInformation()"
        ></app-segment-header>
        <form *ngIf="field" class="ui static form">
            <div class="inline field">
                <label>{{ 'settings.custom-fields.placeholderText' | translate }}</label>
                <p>{{ field?.description }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.fieldType' | translate }}</label>
                <p *ngIf="field.type">{{ field.type | dataFieldType }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.fieldGroup' | translate }}</label>
                <p>{{ field.dataFieldGroup?.name }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.groupLocation' | translate }}</label>
                <p>{{ field.dataFieldGroup?.component | fieldGroupLocation }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.fieldMandatory' | translate }}</label>
                <p>{{ (field.isRequired ? 'forms.fields.yes' : 'forms.fields.no') | translate }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.fieldEncryption' | translate }}</label>
                <p>{{ (field?.isEncrypted ? 'forms.fields.yes' : 'forms.fields.no') | translate }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.editPermissions' | translate }}</label>
                <p *ngIf="field?.roles?.length">
                    <ui-badge *ngFor="let role of field.roles" type="default">
                        {{ role.name | appTranslateOptions: roleNameDisplay }}
                    </ui-badge>
                </p>
                <p *ngIf="!field?.roles?.length" class="notset">{{ 'settings.custom-fields.notSet' | translate }}</p>
            </div>

            <div class="inline field">
                <label>{{ 'settings.custom-fields.viewPermissions' | translate }}</label>
                <p *ngIf="field?.viewOnlyRoles?.length">
                    <span *ngFor="let role of field.viewOnlyRoles" class="ui label">{{
                        role.name | appTranslateOptions: roleNameDisplay
                    }}</span>
                </p>
                <p *ngIf="!field?.viewOnlyRoles?.length" class="notset">
                    {{ 'settings.custom-fields.notSet' | translate }}
                </p>
            </div>

            <div *ngIf="customFieldsOnDocuments" class="inline field">
                <label>{{ 'settings.custom-fields.addedToDocuments' | translate }}</label>
                <p>{{ (field.isEnabledForDocuments ? 'forms.fields.yes' : 'forms.fields.no') | translate }}</p>
            </div>
        </form>
    </div>

    <!-- Employee assigned table -->
    <ng-container *ngIf="field.assignedEmployeesCount; else noEmployeesAssigned">
        <ui-card>
            <app-table
                title="{{ 'settings.custom-fields.employeesAssigned' | translate }}"
                [showSearch]="true"
                [embedded]="true"
                [showOffset]="false"
                [useStickyHeader]="false"
                [table]="assignedEmployeesAndFieldValuesTable"
            >
            </app-table>
        </ui-card>
    </ng-container>

    <!-- Empty state i.e. no employees assigned -->
    <ng-template #noEmployeesAssigned>
        <ui-card>
            <app-empty-state
                src="/assets/illustrations/sofa.png"
                label="{{ 'settings.custom-fields.noEmployeesHaveBeenAssignedToThisField' | translate }}"
            >
            </app-empty-state>
        </ui-card>
    </ng-template>
</div>
